// Chilean Regions and Cities
// Used for standardized location selection across the platform

export const CHILEAN_REGIONS = [
  { value: 'Arica y Parinacota', label: 'Arica y Parinacota' },
  { value: 'Tarapacá', label: 'Tarapacá' },
  { value: 'Antofagasta', label: 'Antofagasta' },
  { value: 'Atacama', label: 'Atacama' },
  { value: 'Coquimbo', label: 'Coquimbo' },
  { value: 'Valparaíso', label: 'Valparaíso' },
  { value: 'Metropolitana', label: 'Metropolitana de Santiago' },
  { value: "O'Higgins", label: "O'Higgins" },
  { value: 'Maule', label: 'Maule' },
  { value: 'Ñuble', label: 'Ñuble' },
  { value: 'Biobío', label: 'Biobío' },
  { value: 'La Araucanía', label: 'La Araucanía' },
  { value: 'Los Ríos', label: 'Los Ríos' },
  { value: 'Los Lagos', label: 'Los Lagos' },
  { value: 'Aysén', label: 'Aysén' },
  { value: 'Magallanes', label: 'Magallanes y la Antártica' }
];

// Cities grouped by region
export const CHILEAN_CITIES_BY_REGION = {
  'Arica y Parinacota': ['Arica', 'Putre'],
  'Tarapacá': ['Iquique', 'Alto Hospicio', 'Pozo Almonte'],
  'Antofagasta': ['Antofagasta', 'Calama', 'Tocopilla', 'Mejillones'],
  'Atacama': ['Copiapó', 'Vallenar', 'Chañaral', 'Diego de Almagro'],
  'Coquimbo': ['La Serena', 'Coquimbo', 'Ovalle', 'Illapel', 'Vicuña'],
  'Valparaíso': ['Valparaíso', 'Viña del Mar', 'Quilpué', 'Villa Alemana', 'San Antonio', 'Quillota', 'Los Andes', 'San Felipe'],
  'Metropolitana': ['Santiago', 'Puente Alto', 'Maipú', 'La Florida', 'Las Condes', 'Providencia', 'Ñuñoa', 'Vitacura', 'Lo Barnechea', 'Peñalolén', 'San Bernardo', 'Colina', 'Buin', 'Melipilla', 'Talagante'],
  "O'Higgins": ['Rancagua', 'San Fernando', 'Rengo', 'Machalí', 'Graneros'],
  'Maule': ['Talca', 'Curicó', 'Linares', 'Constitución', 'Cauquenes'],
  'Ñuble': ['Chillán', 'San Carlos', 'Bulnes', 'Coihueco'],
  'Biobío': ['Concepción', 'Talcahuano', 'Los Ángeles', 'Chiguayante', 'Coronel', 'San Pedro de la Paz', 'Hualpén', 'Tomé'],
  'La Araucanía': ['Temuco', 'Padre Las Casas', 'Villarrica', 'Pucón', 'Angol', 'Victoria'],
  'Los Ríos': ['Valdivia', 'La Unión', 'Río Bueno', 'Panguipulli'],
  'Los Lagos': ['Puerto Montt', 'Osorno', 'Castro', 'Puerto Varas', 'Ancud', 'Calbuco'],
  'Aysén': ['Coyhaique', 'Puerto Aysén', 'Chile Chico'],
  'Magallanes': ['Punta Arenas', 'Puerto Natales', 'Porvenir']
};

// Flat list of all cities with their regions
export const ALL_CHILEAN_CITIES = Object.entries(CHILEAN_CITIES_BY_REGION).flatMap(
  ([region, cities]) => cities.map(city => ({ value: city, label: city, region }))
);

// Get cities for a specific region
export function getCitiesByRegion(region) {
  return CHILEAN_CITIES_BY_REGION[region] || [];
}

// Get region for a city (first match)
export function getRegionByCity(cityName) {
  for (const [region, cities] of Object.entries(CHILEAN_CITIES_BY_REGION)) {
    if (cities.some(city => city.toLowerCase() === cityName.toLowerCase())) {
      return region;
    }
  }
  return null;
}

// For backwards compatibility and search functionality
export const REGION_SEARCH_OPTIONS = [
  { value: '', label: 'Todas las regiones' },
  ...CHILEAN_REGIONS
];
